<template>
  <div class="single-chart">
    <svg
      viewBox="0 0 36 36"
      class="circular-chart blue"
    >
      <defs>
        <linearGradient id="MyGradient">
          <stop
            offset="0%"
            stop-color="rgba(142, 45, 226, 1)"
          />
          <stop
            offset="100%"
            stop-color="rgba(0, 186, 247, 1)"
          />
        </linearGradient>
      </defs>
      <path
        class="circle-bg"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        class="circle"
        :stroke-dasharray="`${percentage}, 100`"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 0 0 31.831
          a 15.9155 15.9155 0 0 0 0 -31.831"
      />
      <text
        x="18"
        y="20.35"
        class="percentage"
      >{{ percentage }}%</text>
    </svg>
  </div>
</template>

<script>
export default {
  props: ["percentage"],
};
</script>

<style scoped>
.flex-wrapper {
  display: flex;
  flex-flow: row nowrap;
}

.single-chart {
  width: 55%;
  display: block;
  margin: auto;
}

.circular-chart {
  display: block;
  max-width: 100%;
  max-height: 250px;
  margin: auto;
}

.circle-bg {
  fill: none;
  stroke: rgba(132, 132, 132, 0.77);
  stroke-width: 0.8;
}

.circle {
  fill: none;
  stroke-width: 1.4;
  stroke-linecap: round;
  /* animation: progress 1s ease-out forwards; */
}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.circular-chart.orange .circle {
  stroke: #ff9f00;
}

.circular-chart.green .circle {
  stroke: #4cc790;
}

.circular-chart.blue .circle {
  stroke: url("#MyGradient");
}

.percentage {
  font-family: sans-serif;
  font-size: 0.5em;
  text-anchor: middle;
}
</style>